import React, { Component, ReactNode, useContext } from 'react';

interface IProps {
  children: ReactNode;
}

interface IStickyState {
  stickyHeight: number;
}

export interface IStickyControl {
  updateStickyHeight(height: number): void;
}

export const StickyHeightControlContext = React.createContext<IStickyControl>({ updateStickyHeight: () => {} });
const StickyHeightContext = React.createContext<number>(0);

export const useStickyHeightControl = () => useContext(StickyHeightControlContext);
export const useStickyHeight = () => useContext(StickyHeightContext);

/**
 * Context to update and access the height of the sticky
 * container (fixed layout) at the top of the page.
 */
export default class StickyContextProvider extends Component<IProps, IStickyState> {
  private readonly stickyHeightCtrl: IStickyControl;

  public constructor(props: IProps) {
    super(props);

    this.state = {
      stickyHeight: 0,
    };

    this.stickyHeightCtrl = {
      updateStickyHeight: (height) => this.updateStickyHeight(height),
    };
  }

  private updateStickyHeight(stickyHeight: number) {
    if (this.state.stickyHeight !== stickyHeight) {
      this.setState({ stickyHeight });
    }
  }

  public render() {
    return (
      <StickyHeightControlContext.Provider value={this.stickyHeightCtrl}>
        <StickyHeightContext.Provider value={this.state.stickyHeight}>
          {this.props.children}
        </StickyHeightContext.Provider>
      </StickyHeightControlContext.Provider>
    );
  }
}
